import { AxiosInstance } from "axios"

import { VerifyOtpRequest, VerifyOtpResponse } from "./otp"

export function verifyPasswordAPI(
  { params }: VerifyOtpRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params,
    method: "post",
    url: "/auth/password/verify",
  }) as Promise<VerifyOtpResponse>
}
